module.exports = __webpack_public_path__ + "static/media/image-app-detail.7214b146.png";